<template>
  <lazy-hydrate
    never
  >
    <component
      :is="component.componentType"
      v-bind="component"
    />
  </lazy-hydrate>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'

export default {
  name: 'AsideComponent',
  components: {
    LazyHydrate,
    FragmentComponent: () => import('./FragmentComponent'),
    ZgCrossSell: () => import('@zc/components/ZgCrossSell/ZgCrossSell')
  },
  props: {
    component: {
      type: Object,
      required: true,
      validator: (component) =>
        ['FragmentComponent', 'ZgCrossSell'].includes(component.componentType)
    }
  }
}
</script>
